<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-new"
      scrollable
      centered
      size="lg"
    >
      <template
        #modal-title
        v-if="this.data.id"
      >
        <i class="fas fa-columns"></i> CRM - Editar Quadro
      </template>
      <template
        #modal-title
        v-else
      >
        <i class="fas fa-columns"></i> CRM - Novo Quadro
      </template>
      <div class="form-group row pt-2 pb-3">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Nome do Quadro:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o nome do quadro'"
              v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state"
            ></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pb-3">
        <div class="col-md-12">
          <label for="txtDescription"> Descrição do Quadro:</label>
          <b-form-textarea
            v-model="form.descricao.value"
            :placeholder="'Digite uma breve descrição sobre o quadro'"
            :rows="form.descricao.rows"
            :size="form.descricao.maxlength"
            :noResize="form.descricao.noResize"
          ></b-form-textarea>
          <!-- <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small> -->
        </div>
      </div>
      <div class="form-group row pb-3">
        <div class="col-md-6">
          <div class="input-group">
            <label><small class="text-danger">*</small> Tipo de Quadro:</label>
            <div class="input-group">
              <b-form-select
                v-model="form.tipoBoard.value"
                :options=" isAjuizamento ? form.tipoBoard.options.slice(3) : form.tipoBoard.options.slice(0, 3)"
                :required="form.tipoBoard.required"
                :state="form.tipoBoard.state"
              ></b-form-select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label>Configurações Gerais:</label>
          <div class="input-group">
            <b-form-checkbox
              v-model="form.permiteDuplicidade.value"
              :disabled="!!this.data.id"
              class="d-flex"
            >
              Permitir Duplicidade
            </b-form-checkbox>
            <b-form-checkbox
              v-model="form.geraCardPorProdutoCobranca.value"
              v-if="form.tipoBoard.value === 'COBRANCA'"
              :disabled="!!this.data.id"
            >
              Gerar oportunidades por produto
            </b-form-checkbox>
            <b-form-checkbox
              v-model="form.geraCardPorAjuizamento.value"
              v-if="form.tipoBoard.value === 'AJUIZAMENTO'"
              :disabled="!!this.data.id"
            >
              Gerar oportunidades por ajuizamento
            </b-form-checkbox>
            <b-form-checkbox
              v-if="form.tipoBoard.value === 'VENDA'"
              v-model="form.ganhoPorProduto.value">
              Permitir Ganho/Perda por produto
            </b-form-checkbox>
            <b-form-checkbox v-model="form.incluirGerenteResp.value">
              Incluir Gerente/Agente como responsável
            </b-form-checkbox>
            <b-form-checkbox :disabled="!!this.data.id" v-model="form.isOportunidadeAssociado.value">
              Somente oportunidades para associados
            </b-form-checkbox>
            <b-form-checkbox v-model="form.alterarResponsavel.value">
              Bloquear alteração de responsável
            </b-form-checkbox>
          </div>
        </div>
        <div class="col-md-12">
          Lista de Produtos do Board:
          <v-select
            multiple
            ref="selectProduto"
            :closeOnSelect="false"
            v-model="form.listaProdutosIds.value"
            :options="form.listaProdutosIds.options"
            :reduce="item => item.value"
            label="text"
            placeholder="Selecione o(s) produto(s)"
          >
            <template v-slot:no-options>{{
                "Nenhum resultado encontrado"
              }}</template>
            <template #list-header>
              <button
                class="btn btn-secondary btn-sm btn-block"
                @click.prevent="handleSelectAll('listaProdutosIds', 'selectProduto')"
              >Selecionar todos</button>
              <button
                class="btn btn-secondary btn-sm btn-block"
                @click.prevent="handleRemoveAll('listaProdutosIds')"
              >Remover todos</button>
            </template>
          </v-select>
        </div>
      </div>
      <div class="form-group row pb-3">
        <div class="col-md-4">
          <label
            >Tempo Limite de Duração:<i
              class="ml-1 cursor-pointer text-third"
              v-b-tooltip.hover
              :title="
                'Clique para alterar para' +
                (!deadlineHoursIsHours ? ' horas' : ' dias')
              "
              @click="toggleTypeDayHourdeadlineHours"
              :class="
                deadlineHoursIsHours ? 'fas fa-calendar-alt' : 'fas fa-clock'
              "
            ></i
          ></label>
          <b-form-input
            type="text"
            :placeholder="
              'Digite a quantidade de ' +
              (deadlineHoursIsHours ? 'horas' : 'dias')
            "
            v-model="form.deadlineHours.value"
            :required="form.deadlineHours.required"
            :state="form.deadlineHours.state"
            maxlength="3"
            v-only-numeric
          >
          </b-form-input>
        </div>
        <div class="col-md-4">
          <label><small class="text-danger">*</small> Data de Inicio:</label>
          <b-form-input
            type="date"
            v-model="form.dataInicial.value"
            :required="form.dataInicial.required"
            :state="form.dataInicial.state"
          ></b-form-input>
        </div>
        <div class="col-md-4">
          <label>
            <small class="text-danger">*</small> Data de Término:
            <i
              class="ml-1 cursor-pointer text-third fas fa-lightbulb"
              v-b-tooltip.hover
              title="Após a data especificada, o quadro será configurado para o modo somente leitura, não permitindo mais alterações."
            ></i>
          </label>
          <b-form-input
            type="date"
            v-model="form.dataFinal.value"
            :required="form.dataFinal.required"
            :state="form.dataFinal.state"
          ></b-form-input>
        </div>
        <div
          @click="showSatisfactionInput = !showSatisfactionInput"
          class="d-flex w-100 mt-5 px-3 cursor-pointer"
        >
          <h5 class="text-third mr-3">Pesquisa de Satisfação</h5>
          <i
            :class="
              'fas text-third' +
              (showSatisfactionInput ? ' fa-caret-down' : ' fa-caret-right')
            "
            style="font-size: 1.5rem"
          ></i>
        </div>
        <div
          class="form-group row w-100 m-0"
          v-show="showSatisfactionInput"
        >
          <div class="col-md-6">
            <label for="txtGroup">Template de Ganho:</label>
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="fas fa-user-check"></i
              ></span>
              <b-form-select
                v-model="form.templateGanhoId.value"
                :options="form.templateGanhoId.options"
              >
                <template slot="first">
                  <option :value="null">
                    {{ $lang.Common.PlaceholderSelect }}
                  </option>
                </template>
              </b-form-select>
            </div>
          </div>
          <div class="col-md-6">
            <label for="txtGroup">Template de Perda:</label>
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="fas fa-heart-broken"></i
              ></span>
              <b-form-select
                v-model="form.templatePerdaId.value"
                :options="form.templatePerdaId.options"
              >
                <template slot="first">
                  <option :value="null">
                    {{ $lang.Common.PlaceholderSelect }}
                  </option>
                </template>
              </b-form-select>
            </div>
          </div>
          <div class="col-md-12 mt-2">
            <label for="txtGroup">Template de Finalizado:</label>
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="fas fa-heart-broken"></i
              ></span>
              <b-form-select
                v-model="form.templateFinalizadoId.value"
                :options="form.templateFinalizadoId.options"
              >
                <template slot="first">
                  <option :value="null">
                    {{ $lang.Common.PlaceholderSelect }}
                  </option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="checkConfirm"
            v-b-tooltip.hover
            :title="'Salvar'"
          >
            <i class="fas fa-check-circle"></i
            ><span class="d-md-down-none"> Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
    <AddConfirmation
      ref="confirmation-modal"
      :saveFunction="onSave"
      :warnText="confirmationWarningText"
    />
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import AccountRepository from '@/shared/http/repositories/access/account.js'
import ProductRepository from '@/shared/http/repositories/configurations/product.js'
import CampanhaModeloRepository from '@/shared/http/repositories/configurations/templates.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import NxSelectProduto from '../../../../components/nexum/components/custom-selects/NxSelectProduto.vue'

const CRMNewForm = {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  descricao: {
    value: '',
    maxlength: '70',
    required: false,
    rows: '3',
    noResize: true
  },
  dataInicial: {
    value: '',
    required: true,
    state: null
  },
  dataFinal: {
    value: '',
    required: true,
    state: null
  },
  permiteDuplicidade: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  incluirGerenteResp: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  ganhoPorProduto: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  geraCardPorProdutoCobranca: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  geraCardPorAjuizamento: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  templateGanhoId: {
    value: null,
    defaultValue: null,
    required: false,
    state: null,
    options: []
  },
  templatePerdaId: {
    value: null,
    defaultValue: null,
    required: false,
    state: null,
    options: []
  },
  templateFinalizadoId: {
    value: null,
    defaultValue: null,
    required: false,
    state: null,
    options: []
  },
  isOportunidadeAssociado: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  alterarResponsavel: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  tipoBoard: {
    value: null,
    options: [
      { text: 'Venda', value: 'VENDA' },
      { text: 'Cobrança', value: 'COBRANCA' },
      { text: 'Operação', value: 'OPERACAO' },
      { text: 'Ajuizamento', value: 'AJUIZAMENTO' }
    ],
    required: true
  },
  deadlineHours: {
    value: '',
    required: false,
    state: null
  },
  listaProdutosIds: {
    value: null,
    options: [],
    required: false
  }
}

export default {
  name: 'CRMNew',
  mixins: [ActionsForm],
  components: {
    NxSelectProduto,
    AddConfirmation
  },
  data () {
    return {
      data: {
        id: null,
        nome: null,
        favorito: null,
        tipo: null,
        descricao: null,
        dataInicial: null,
        dataFinal: null,
        permiteDuplicidade: false,
        incluirGerenteResp: false,
        isOportunidadeAssociado: false,
        ganhoPorProduto: false,
        geraCardPorProdutoCobranca: false,
        geraCardPorAjuizamento: false,
        templateGanhoId: null,
        templatePerdaId: null,
        templateFinalizadoId: null,
        tipoBoard: null,
        deadlineHours: null,
        listaProdutosIds: null,
        alterarResponsavel: false
        // usuariosPermissaoIds: null
      },
      deadlineHoursIsHours: true,
      form: CRMNewForm,
      showSatisfactionInput: false,
      confirmationWarningText: ''
    }
  },
  props: {
    isAjuizamento: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    onlyNumeric: {
      bind (el) {
        el.addEventListener('input', () => {
          el.value = el.value.replace(/[^0-9]/g, '')
        })
      }
    }
  },
  watch: {
    'form.listaProdutosIds.options': function (newOptions) {
      if (newOptions.length > 0) {
        this.$nextTick(() => {
          this.$refs.selectProduto.refresh()
        })
      }
    }
  },
  methods: {
    test (val) {
      if (val !== 'COBRANCA') this.form.geraCardPorProdutoCobranca.value = false
      if (val !== 'AJUIZAMENTO') this.form.geraCardPorAjuizamento.value = false
    },
    showModal () {
      this.onClear()
      this.onGetAllTemplates()
      this.form.dataInicial.value = String(
        new Date().toLocaleDateString('en-CA')
      )
      this.$refs['modal-new'].show()
    },
    hideModal () {
      this.$refs['modal-new'].hide()
    },
    onLoad () {
      this.onClear()
      this.onEdit(this.data)
      this.onLoadAllAccount()
      this.onLoadAllProducts()
    },
    async onEdit (obj) {
      if (obj) {
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.dataInicial) {
          this.form.dataInicial.value = this.moment(
            obj.dataInicial.substring(0, 19)
          ).format('YYYY-MM-DD')
        }

        if (obj.dataFinal) {
          this.form.dataFinal.value = this.moment(
            obj.dataFinal.substring(0, 19)
          ).format('YYYY-MM-DD')
        }

        if (obj.templateGanhoId) {
          this.form.templateGanhoId.value = obj.templateGanhoId
        }

        if (obj.templatePerdaId) {
          this.form.templatePerdaId.value = obj.templatePerdaId
        }

        if (obj.templateFinalizadoId) {
          this.form.templateFinalizadoId.value = obj.templateFinalizadoId
        }

        if (obj.listaProdutos) {
          this.form.listaProdutosIds.value = obj.listaProdutos.map((x) => x.id)
        }

        // if (obj.usuariosPermissao) {
        //   this.form.usuariosPermissao.value = obj.usuariosPermissao.map(responsavel => responsavel.id) || []
        // }
      }
    },
    onCreate () {
      loading.push()
      this.data.favorito = false
      this.data.tipo = 0
      this.data.listaProdutosIds = this.form.listaProdutosIds.value

      // IF USER SETS NUM OF DAYS, TRANSFORM TO HOURS BEFORE SENDING TO API
      this.daysToHoursIfDaysSet()

      // if (this.form.usuariosPermissao.value && this.form.usuariosPermissao.value.length !== 0) {
      //   this.data.usuariosPermissaoIds = this.form.usuariosPermissao.value
      // }
      BoardRepository.Create(this.data)
        .then((response) => {
          loading.pop()
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
          this.hideModal()
          this.$emit('Back')
        })
        .catch(this.onException)
    },
    handleSelectAll (fieldName, refName) {
      const select = this.$refs[refName]
      const visibleOptions = select.filteredOptions.map(option => option.value)
      this.form[fieldName].value = visibleOptions
    },
    handleRemoveAll (fieldName) {
      this.form[fieldName].value = []
    },
    onUpdate () {
      loading.push()
      this.data.favorito = false
      this.data.tipo = 0
      this.data.listaProdutosIds = this.form.listaProdutosIds.value

      // IF USER SETS NUM OF DAYS, TRANSFORM TO HOURS BEFORE SENDING TO API
      this.daysToHoursIfDaysSet()

      // if (this.form.usuariosPermissao.value.length !== 0) {
      //   this.data.usuariosPermissaoIds = this.form.usuariosPermissao.value
      // }
      BoardRepository.Update(this.data)
        .then((response) => {
          loading.pop()
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
          this.hideModal()
          this.$emit('Back')
        })
        .catch(this.onException)
    },
    onGetAllTemplates () {
      loading.push()
      CampanhaModeloRepository.Search('tipo=1&finalidade=2&', 500, 0)
        .then((response) => {
          this.form.templateGanhoId.options = this.onResultDropdown(response)
          this.form.templatePerdaId.options = this.onResultDropdown(response)
          this.form.templateFinalizadoId.options =
            this.onResultDropdown(response)
        })
        .catch(this.onException)
    },
    onLoadAllAccount () {
      loading.push()
      AccountRepository.GetAllName()
        .then((response) => {
          loading.pop()
          // this.form.usuariosPermissao.options = response.data.map(usuario => ({ 'text': usuario.nomePessoa, 'value': usuario.id }))
        })
        .catch((e) => {
          loading.pop()
          console.log(e.message)
        })
    },
    onLoadAllProducts () {
      loading.push()
      ProductRepository.GetAllActive()
        .then((response) => {
          loading.pop()
          this.form.listaProdutosIds.options = response.data.content.map(produto => ({ 'text': produto.nome, 'value': produto.id }))
        })
        .catch((e) => {
          loading.pop()
          console.log(e.message)
        })
    },
    checkConfirm () {
      if (!this.data.id) {
        if (this.form.permiteDuplicidade.value) {
          this.confirmationWarningText =
            'Permitir duplicidade não pode ser desabilitado posteriormente. Deseja continuar?'
          this.$refs['confirmation-modal'].showModal()
        } else if (this.form.geraCardPorProdutoCobranca.value) {
          this.confirmationWarningText =
            'Gerar card por produto ativara permitir duplicidade e ambos não poderão ser desabilitados posteriormente. Deseja continuar?'
          this.$refs['confirmation-modal'].showModal()
        } else if (this.form.geraCardPorAjuizamento.value) {
          this.confirmationWarningText =
            'Gerar card por ajuizamento ativara permitir duplicidade e ambos não poderão ser desabilitados posteriormente. Deseja continuar?'
          this.$refs['confirmation-modal'].showModal()
        } else if (
          !this.form.permiteDuplicidade.value &&
          !this.form.geraCardPorProdutoCobranca.value &&
          !this.form.geraCardPorAjuizamento.value
        ) this.onSave()
        return
      }
      this.onSave()
    },
    toggleTypeDayHourdeadlineHours () {
      if (this.form.deadlineHours.value > 0) {
        this.convertDaysAndHours()
      }
      this.deadlineHoursIsHours = !this.deadlineHoursIsHours
    },
    convertDaysAndHours () {
      if (this.deadlineHoursIsHours) {
        this.form.deadlineHours.value = this.hoursToDays(
          this.form.deadlineHours.value
        )
      } else if (!this.deadlineHoursIsHours) {
        this.form.deadlineHours.value = this.daysToHours(
          this.form.deadlineHours.value
        )
      }
    },
    daysToHoursIfDaysSet () {
      // IF USER SETS NUM OF DAYS, TRANSFORM TO HOURS BEFORE SENDING TO API
      if (!this.deadlineHoursIsHours && this.form.deadlineHours.value) {
        this.data.deadlineHours = this.daysToHours(
          this.form.deadlineHours.value
        )
      }
    },
    daysToHours (days) {
      return days * 24
    },
    hoursToDays (hours) {
      return parseInt(hours / 24)
    },
    async handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.form[fieldName].value = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName].value = Array.isArray(selectedValue)
          ? selectedValue.map((v) => v.value)
          : selectedValue.value
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (field) {
      if (field !== null) this.form[field].value = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/modal/crmnewmodal.vue